// extracted by mini-css-extract-plugin
export var menu = "menu-module--menu--1xkjQ";
export var menuText = "menu-module--menu-text--aHHWm";
export var menuIcon = "menu-module--menu-icon--GSWc4";